import React, { useState } from "react"
import { Link } from "react-router-dom"
import NavUserProfileDropDown from "./NavUserProfileDropDown"
import NotificationOffCanvas from "./notification/NotificationOffCanvas"
import {
  bellIcon,
  admiLogo,
  menuHamburgerIcon,
  menuCloseIcon,
} from "../../../constants/icons"

function NavigationBar() {
  const [show, setShow] = useState(false)
  const [menuActive, setMenuActive] = useState(false)

  const handleShow = () => {
    setShow(true)
  }

  const handleClose = () => {
    setShow(false)
  }

  const onHamburgerClick = () => {
    const body = document.body
    if (menuActive) {
      body.classList.remove("menu-active")
    } else {
      body.classList.add("menu-active")
    }
    setMenuActive(!menuActive)
  }

  return (
    <>
      <nav className='navbar navbar-expand-md sticky-top backdrop-filter'>
        <div className='container-fluid'>
          <div className='logo-toggle-wrapper d-flex align-items-center gap-4'>
            <div
              className='mobile-menu d-flex gap-2 d-md-none'
              onClick={onHamburgerClick}
            >
              <span className='sidebar-toggle'>
                {menuActive ? menuCloseIcon : menuHamburgerIcon}
              </span>
            </div>
            <a className='navbar-brand admin-logo-wrap' href='#top'>
              {admiLogo}
            </a>
          </div>
          <div className='mobile-menu d-flex align-items-center gap-4'>
            {/* <ul className="navbar-nav mb-lg-0 d-flex gap-3">
              <li className="nav-item">
                <Link className="nav-link position-relative" to="#" onClick={handleShow}>
                  {bellIcon}
                  <div className="notification-count">3</div>
                </Link>
              </li>
            </ul> */}
            <NavUserProfileDropDown />
          </div>
        </div>
      </nav>

      <NotificationOffCanvas show={show} onClose={handleClose} />
    </>
  )
}

export default NavigationBar
